import PropTypes from 'prop-types';
import React from 'react';
import FilterString from '../../FilterString';

const NumberRenderer = ({ name, operator, renderSettings, value }) => (
  <FilterString name={name} operator={operator} value={value} renderSettings={renderSettings} />
);

NumberRenderer.propTypes = {
  name: PropTypes.string,
  operator: PropTypes.string,
  renderSettings: PropTypes.object,
  value: PropTypes.array,
};

NumberRenderer.defaultProps = {
  name: '',
  operator: '',
  renderSettings: {},
  value: [],
};

export default NumberRenderer;
